import rootStyles from "~/components/Root.module.scss";
import Tooltip from "~/components/Tooltip";
import styles from "~/components/player/SongLyricsButton.module.scss";

interface SongLyricsButtonProps {
  readonly alternate?: boolean;
}

export default function SongLyricsButton(props: SongLyricsButtonProps) {
  return (
    <Tooltip
      content="Acompanhar Letra"
      as="a"
      classList={{
        [styles.button]: true,
        [styles.alternate]: props.alternate,
      }}
      href="#song-lyrics"
    >
      <IconTablerPlaylist />
      <span class={rootStyles["sr-only"]}>Acompanhar Letra</span>
    </Tooltip>
  );
}
